import './styles.css';
import { BoxModal } from '../../../components/boxModal';
import { PixKey } from '../pix-key'
import { TbCircleKey } from 'react-icons/tb'
import * as RadioGroup from '@radix-ui/react-radio-group';
import BeatLoader from "react-spinners/BeatLoader";
import { MessageToCache, MethodToCache, PullerGetAllPixKeyList } from '../../../services/puller.service';




export const CreatePix = ({handleCloseModal, userData, loader, rows, getKeys, override, handleCreateNewKey, typeKey, setTypeKey, isPF, showConfirmationCodeModal, closeConfirmationCodeModal}) => {
  return (
    <BoxModal title='Gerenciamento de Chaves Pix' maxWidth={800} maxHeight={801} close={handleCloseModal}>
            <div className='keys-modal-content'>
              <div className='keys-modal-section'>
                <h3>Minhas Chaves</h3>

                <div className='my-keys'>
                  {
                    !loader
                    ? (
                      <>
                        {
                          rows.length
                          ? (
                            rows.map((item) => (
                              <PixKey
                                key={item.id}
                                id={item.id}
                                type={item.type}
                                keyValue={item.key}
                                getKeys={getKeys}
                                status={item.status}
                                showConfirmationCodeModal={showConfirmationCodeModal}
                                setTypeKey={setTypeKey}
                              />
                            ))
                          ) : (
                            <span>Vazio...</span>
                          )
                        }
                      </>
                    ) : (
                      <BeatLoader
                        color={"var(--secondary-color)"}
                        loading={loader}
                        css={override}
                        size={20}
                      />
                    )
                  }
                </div>
              </div>

              <div className='keys-modal-section'>
                <h3>Cadastrar nova Chave</h3>

                <form className='new-key-container' onSubmit={handleCreateNewKey}>
                  <RadioGroup.Root
                    className="new-key-radio-root"
                    defaultValue="4"
                    value={typeKey}
                    onValueChange={(value) => setTypeKey(value)}
                    id='cpf'
                    required
                  >
                    <div className='new-key-radio-item'>
                      <RadioGroup.Item className="new-key-radio-button" value={isPF? 0 : 1} id={isPF ? "cpf" : "cnpj"}>
                        <RadioGroup.Indicator className="new-key-radio-indicator" />
                      </RadioGroup.Item>
                      <label className="new-key-radio-label" htmlFor={isPF ? "cpf" : "cnpj"}>
                        {isPF ? "CPF" : "CNPJ"}
                        <strong>{userData?.taxNumber}</strong>
                      </label>
                    </div>

                    <div className='new-key-radio-item'>
                      <RadioGroup.Item className="new-key-radio-button" value={2} id="email">
                        <RadioGroup.Indicator className="new-key-radio-indicator" />
                      </RadioGroup.Item>
                      <label className="new-key-radio-label" htmlFor="email">
                        E-mail
                        <strong>{userData?.mail}</strong>
                      </label>
                    </div>

                    <div className='new-key-radio-item'>
                      <RadioGroup.Item className="new-key-radio-button" value={3} id="tel">
                        <RadioGroup.Indicator className="new-key-radio-indicator" />
                      </RadioGroup.Item>
                      <label className="new-key-radio-label" htmlFor="tel">
                        Celular
                        <strong>{userData?.phoneNumber}</strong>
                      </label>
                    </div>

                    <div className='new-key-radio-item'>
                      <RadioGroup.Item className="new-key-radio-button" value={4} id="random">
                        <RadioGroup.Indicator className="new-key-radio-indicator" />
                      </RadioGroup.Item>
                      <label className="new-key-radio-label" htmlFor="random">
                        <strong>Chave aleatória</strong>
                      </label>
                    </div>

                  </RadioGroup.Root>

                  <button disabled={typeKey == null ? true : false} className='new-key-button'>Cadastrar chave pix</button>
                </form>
              </div>
            </div>
          </BoxModal>
  );
}
